import { useTranslation } from 'react-i18next';
import CustomSelectField from 'components/forms/customSelectField/CustomSelectField';
import useAppUser from 'hooks/useAppUser';
import { useFormContext } from 'react-hook-form';
import { LanguageCodeUnderscored } from 'i18n/internationalization.types';
import useAgencyOwners from '../../useAgencyOwners';
import { StyledSubTitle } from './OwnerModal.styles';

const LinkExistingOwner = () => {
  const { t } = useTranslation();
  const { agencyUid } = useAppUser();
  const { resetField, setValue } = useFormContext();

  const { data: agencyOwners, isLoading } = useAgencyOwners({
    agencyUid: agencyUid ?? '',
    enabled: !!agencyUid,
  });

  const agencyOwnersOptions =
    agencyOwners?.owners.map((owner) => {
      const fullName = [owner.firstName, owner.lastName]
        .filter(Boolean)
        .join(' ');

      return {
        value: owner.uid,
        label: fullName ? `${fullName} - ${owner.email}` : owner.email,
      };
    }) ?? [];

  const handleLinkExistingOwner = (ownerUid: string | null) => {
    if (ownerUid === null) {
      resetField('owner');
      return;
    }

    const owner = agencyOwners?.owners?.find((o) => o.uid === ownerUid);

    const phoneNumberAreaCode = owner?.phoneNumberAreaCode
      ? `+${owner?.phoneNumberAreaCode}`
      : '+1';

    const ownerFormValues = {
      businessName: owner?.businessName ?? '',
      ccEmails: owner?.ccEmails ?? '',
      email: owner?.email,
      firstName: owner?.firstName ?? '',
      lastName: owner?.lastName ?? '',
      phoneNumber: `${phoneNumberAreaCode}${owner?.phoneNumber ?? ''}`,
      phoneNumber_areaCode: phoneNumberAreaCode,
      phoneNumber_base: owner?.phoneNumber ?? '',
      preferredLocale: owner?.preferredLocale ?? LanguageCodeUnderscored.EN_US,
      uid: owner?.uid ?? '',
      agencyCommissionRate: owner?.agencyCommissionRate ?? 0,
      permissionTypes: owner?.permissionTypes ?? null,
      pictureUrl: owner?.pictureUrl ?? null,
    };

    setValue('owner', ownerFormValues);
  };

  return (
    <div data-testid="link-existing-owner">
      <StyledSubTitle>
        {t('pageProperty.owners.modal.linkAnExistingOwner')}
      </StyledSubTitle>

      <CustomSelectField
        label="Search owners"
        name="linkedOwnerUid"
        options={agencyOwnersOptions}
        colSmInput={8}
        colSmLabel={4}
        isSearchable
        isClearable
        isLoading={isLoading}
        onChangeHandler={handleLinkExistingOwner}
      />
    </div>
  );
};

export default LinkExistingOwner;
